/* eslint-disable react-hooks/exhaustive-deps */

import { SessionContextProvider } from "@/contexts/SessionContext";
import { AppProviders } from "@/contexts/AppProviders";
import { PatientQuestionnairePage } from "@/pages/patientquestionnaire/PatientQuestionnairePage";

export default function PatientQuestionnaireRoute() {
  return (
    <SessionContextProvider>
      <AppProviders>
        <PatientQuestionnairePage />
      </AppProviders>
    </SessionContextProvider>
  );
}

